document.addEventListener('DOMContentLoaded', function() {
let wrapperOfProductColors = document.querySelectorAll('.color-swatch-list.circle-small');
let toggleButtons = document.querySelectorAll('.toggle-swatches');
let screen = window.screen.width;
let limitColorsNumbersMobile = +wrapperOfProductColors[0].getAttribute('data-swatch-mobile');
let limitColorsNumbersTablet = +wrapperOfProductColors[0].getAttribute('data-swatch-tablet');
let limitColorsNumbersLaptop = +wrapperOfProductColors[0].getAttribute('data-swatch-laptop');
let limitColorsNumbers;

if(screen > 0 && screen < 768) {
  limitColorsNumbers = limitColorsNumbersMobile;
}

if(screen >= 768 && screen < 960) {
  limitColorsNumbers = limitColorsNumbersTablet;
}

if(screen >= 960 ) {
  limitColorsNumbers = limitColorsNumbersLaptop;
}

toggleButtons.forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    let wrapper = button.parentNode;
    let showlessButton = wrapper.querySelector('.show-less-swatches');
    let showMoreButton = wrapper.querySelector('.show-more-swatches');
    let currentColors = wrapper.querySelectorAll('a:not(.toggle-swatches)');
    let buttonAction = button.classList.contains('show-more-swatches') ? 'show-more' : 'show-less';

    if(buttonAction === 'show-more') {
      removeClassArray(currentColors, 'hide');
      toggleClass(showMoreButton, showlessButton, 'active');

    } else {
      hideSwtaches(currentColors);
      toggleClass(showlessButton, showMoreButton, 'active');

    }
  })
})

wrapperOfProductColors.forEach(wrapper => {
  let currentColorsNumbers = wrapper.querySelectorAll('a:not(.toggle-swatches)').length;

  if(currentColorsNumbers > limitColorsNumbers) {
    let buttonShowMore = wrapper.querySelector('.show-more-swatches');
    let currentColors = wrapper.querySelectorAll('a:not(.toggle-swatches)');

    hideSwtaches(currentColors);
    buttonShowMore.classList.add('active');
  }
});

function removeClassArray(array, className) {
  array.forEach(element => {
    element.classList.remove(`${className}`);
  });
}

function hideSwtaches(currentColors) {
  currentColors.forEach((color, indexItem) => {
    indexItem++;
    if(indexItem > limitColorsNumbers) {
      color.classList.add('hide');
    }
  })
}

function toggleClass(elem1, elem2, className) {
  elem1.classList.remove(`${className}`);
  elem2.classList.add(`${className}`);
}
});